import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  fetchCategoriesApiThunk,
  createCategoriesApiThunk,
  getCategoriesApiThunk,
  updateCategoriesApiThunk,
} from './categoriesSlice';
import {
  ListCategoriesRequest,
  CreateCategoriesRequest,
  GetCategoriesRequest,
  UpdateCategoriesRequest,
} from 'src/types/helios/Category';
import { RootState } from '..';

export const useCategories = () => {
  const dispatch = useAppDispatch();
  const categoriesList = useAppSelector((state: RootState) => state.categories.category);
  const fetchCategoriesApiStatus = useAppSelector(
    (state: RootState) => state.categories.fetchCategoriesApiStatus,
  );
  const createCategoriesApiStatus = useAppSelector(
    (state: RootState) => state.categories.createCategoriesApiStatus,
  );
  const getCategoriesApiStatus = useAppSelector(
    (state: RootState) => state.categories.getCategoriesApiStatus,
  );
  const updateCategoriesApiStatus = useAppSelector(
    (state: RootState) => state.categories.updateCategoriesApiStatus,
  );
  const loadCategories = useCallback(
    (data: ListCategoriesRequest) => {
      dispatch(fetchCategoriesApiThunk(data));
    },
    [dispatch],
  );
  const createCategories = useCallback(
    (data: CreateCategoriesRequest) => {
      dispatch(createCategoriesApiThunk(data));
    },
    [dispatch],
  );
  const getCategories = useCallback(
    async (data: GetCategoriesRequest) => {
      dispatch(getCategoriesApiThunk(data));
    },
    [dispatch],
  );
  const updateCategories = useCallback(
    async (data: UpdateCategoriesRequest) => {
      dispatch(updateCategoriesApiThunk({ data }));
    },
    [dispatch],
  );

  const clearAPIStatusMessage = useCallback(() => {
    dispatch({ type: 'categories/clearAPIStatusMessageFromState' });
  }, [dispatch]);

  return {
    categoriesList,
    fetchCategoriesApiStatus,
    createCategoriesApiStatus,
    getCategoriesApiStatus,
    updateCategoriesApiStatus,
    loadCategories,
    createCategories,
    getCategories,
    updateCategories,
    clearAPIStatusMessage,
  };
};
